import { AfterContentChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { DynamicBarService } from '../../../../_components/dynamic-bar/dynamic-bar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MapaCurricularService } from '../_services/mapa-curricular.service';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { finalize, map, scan, tap } from 'rxjs/operators';
import { Unidad } from '../../../../_models/unidad';
import { Meta } from '../../../../_models/meta';
import { Title } from '@angular/platform-browser';
import { ThrobberService } from '../../../../_services/throbber.service';
import { EstudioConexionesService } from '../_services/estudio-conexiones.service';
import { UnidadFormDialogComponent } from '../../unidad-form/unidad-form-dialog.component';
import { MetaFormDialogComponent } from '../../meta-form-dialog/meta-form-dialog.component';
import { MapaCurricularFiltrosService } from '../_services/mapa-curricular-filtros.service';
import { MapaMetasComponent } from '../../mapa-metas/mapa-metas.component';
import { AccountService } from 'src/app/_services/account.service';

@Component({
  standalone: false,
  templateUrl: 'mapa-generado.component.html',
  styleUrls: ['../mapa-curricular.component.scss']
})

export class MapaGeneradoComponent implements OnInit, AfterContentChecked, OnDestroy {

  private rolesImportar = ['Admin', 'JefeArea', 'Directivo'];
  importar = false;

  @ViewChildren(MatExpansionPanel) viewPanels: QueryList<MatExpansionPanel>;
  private metasSubject = new Subject<any>();
  private metasSub = new Subscription();
  metas$ = this.metasSubject.asObservable()
    .pipe(
      scan((acc, val) => {
        this.throbberServ.setThrobberState(false);
        // this.filtrosService.updateFiltro();
        if (val.op === 'edit') {
          const metaI = acc.findIndex(metaA => metaA.id === val.items.id);
          acc[metaI] = val.items;
          return acc;
        }
        if (val.op === 'add') {
          return acc.concat(val.items);
        }
        if (val.op === 'remove') {
          return acc.filter(el => el.categoria.ordenAgrupador !== val.category);
        }

      }, []),
      map(metas => {
        return metas.map(meta => new Meta(meta));
      })
    );


  private unidadesSubject = new BehaviorSubject<any>([]);
  private unidadesSub = new Subscription();
  unidades$ = this.unidadesSubject.asObservable().pipe(
    scan((acc, val) => {
      this.throbberServ.setThrobberState(false);
      if (val.op === 'edit') {
        const unidadI = acc.findIndex(unidadA => unidadA.id === val.items.id);
        acc[unidadI] = val.items;
        return acc;
      }
      if (val.op === 'add') {
        return acc.concat(val.items);
      }
      if (val.op === 'remove') {
        return acc.filter(el => el.periodo.id !== val.yearID);
      }
    }),
    map(unidades => unidades.map(unidad => new Unidad(unidad)))
  );

  metasConexiones$ = combineLatest([
    this.metas$,
    this.unidades$,
    this.conexionesService.connectionsStatusAction$
  ])
    .pipe(
      map(([metas, unidades, conexiones]) => {
        const emisores = [];
        this.botonesConexionesVisibilidad = conexiones.length > 0;
        conexiones.map(conexion => {
          const objEmisor = conexion.tipoEmisor === 'meta'
            ? metas.find(meta => meta.id === conexion.idEmisor) : unidades.find(unidad => unidad.id === conexion.idEmisor);
          objEmisor.conexiones = conexion;
          emisores.push(objEmisor);
        });
        // connections status reset.
        metas.map(meta => meta.conexionesActivas = []);
        unidades.map(unidad => unidad.conexionesActivas = []);

        emisores.map(emisor => {
          let metasCon = metas.filter(meta => emisor.metas.indexOf(meta.id) > -1),
            unidadesCon = [];
          if (emisor instanceof Meta) {
            unidadesCon = unidades.filter(unidad => emisor.unidades.indexOf(unidad.id) > -1);
          }
          if (emisor instanceof Meta && !emisor.conexiones.status.up) {
            metasCon = metasCon.filter(meta => meta.categoria.ordenAgrupador !== emisor.categoria.ordenAgrupador - 1);
          }
          if (emisor instanceof Meta && !emisor.conexiones.status.same) {
            metasCon = metasCon.filter(meta => meta.categoria.ordenAgrupador !== emisor.categoria.ordenAgrupador);
          }
          if (emisor instanceof Meta && !emisor.conexiones.status.down) {
            metasCon = metasCon.filter(meta => meta.categoria.ordenAgrupador !== emisor.categoria.ordenAgrupador + 1);
          }
          metasCon.map(metaCon => {
            if (!metaCon.conexionesActivas.find(conexionActiva => conexionActiva.codigo === emisor.getCodigo())) {
              metaCon.conexionesActivas.push({ codigo: emisor.getCodigo(), color: emisor.conexiones.activeColor });
            }
          });
          unidadesCon.map(unidadCon => {
            if (!unidadCon.conexionesActivas.find(conexionActiva => conexionActiva.codigo === emisor.getCodigo())) {
              unidadCon.conexionesActivas.push({ codigo: emisor.getCodigo(), color: emisor.conexiones.activeColor });
            }
          });
        });

        return { metas, unidades };
      })
    );

  cuentaUnidadesConexion = 0;
  cuentaUnidadesSinConexion = 0;

  private onlyConnectedVisibilitySubject = new BehaviorSubject(false);
  onlyConnectedVisibilityAction$ = this.onlyConnectedVisibilitySubject.asObservable();

  fullData$ = combineLatest([
    this.metasConexiones$,
    this.onlyConnectedVisibilityAction$
  ])
    .pipe(
      map(([data, onlyConnected]) => {
        let metas = data.metas,
          unidades = data.unidades;
        this.periodos.map(periodo => {
          periodo['show'] = unidades.filter(unidad => unidad.periodo.id === periodo.id).length > 0;
        });
        if (onlyConnected) {
          metas = metas.filter(meta => meta.conexiones.active || meta.conexionesActivas.length > 0);
          unidades = unidades.filter(unidad => unidad.conexiones.active || unidad.conexionesActivas.length > 0);
        }
        return { metas: metas, unidades: unidades };
      })
    );

  // Variables para el control del menú que presenta los documentos relacionado con el mapa curricular generado.
  @ViewChild('trial', { static: false }) trigger: MatMenuTrigger;
  @ViewChild('menuDoc', { static: false }) menuDoc: MatMenu;
  private menuDocsSubject = new Subject();
  menuDocs$ = this.menuDocsSubject.asObservable();

  cursos;
  areas;
  categoriasMetas;
  ambitos;
  tags;
  periodos;
  profesores;
  materiasPeriodo;
  alumnosIEP;

  textoBusquedaCursos = '';
  textoBusquedaAreas = '';
  arrayBusquedaCursos = [];
  arrayBusquedaAreas = [];

  botonesConexionesVisibilidad = false;

  filtersStatus = true;

  dataReady = false;
  documentos: any;

  constructor(private title: Title,
    private dynamicBarService: DynamicBarService,
    private route: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private matDialogRef: MatDialog,
    private mapaCurricularService: MapaCurricularService,
    private conexionesService: EstudioConexionesService,
    private throbberServ: ThrobberService,
    private filtrosService: MapaCurricularFiltrosService,
    private userService: AccountService) {
  }

  ngOnInit() {
    const roles = this.userService.getUser().rol;
    roles.forEach(item => {
      if (this.rolesImportar.findIndex(rol => rol === item) > -1) {
        this.importar = true;
      }
    });

    this.throbberServ.setThrobberState(true);
    this.title.setTitle('MiGLM - Mapa curricular');
    this.dynamicBarService.setBarra('estudio-mapa-curricular');
    /*const idsMaterias = this.route.snapshot.paramMap.get('idsMateria'),
      idsCursos = this.route.snapshot.paramMap.get('idsCurso'),
      getUnidades = this.route.snapshot.paramMap.get('getUnidades');*/

    this.route.data
      .subscribe((
        data: {
          cursos: any[],
          areas: any[],
          categoriasMetas: any[],
          ambitos: any[],
          tags: any[],
          periodos: any[],
          profesores: any[],
          materiasPeriodo: any[],
          alumnosIEP: any[],
          mcpList: any[]
        }
      ) => {
        this.cursos = data.cursos;
        this.areas = data.areas;
        this.categoriasMetas = data.categoriasMetas;
        this.ambitos = data.ambitos;
        this.tags = data.tags;
        this.periodos = data.periodos;
        this.profesores = data.profesores;
        this.materiasPeriodo = data.materiasPeriodo;
        this.alumnosIEP = data.alumnosIEP;
        this.categoriasMetas.map((val, i) => val['visible'] = (i === (this.categoriasMetas.length - 1)));
      });


    this.route.params.subscribe(data => {
      const idsMaterias = this.route.snapshot.paramMap.get('idsMateria'),
        idsCursos = this.route.snapshot.paramMap.get('idsCurso');
      this.textoBusquedaCursos = '';
      this.textoBusquedaAreas = '';
      this.textoBusquedaCursos = '';
      idsCursos.split(',').forEach(id => {
        this.cursos.filter(curso => {
          if (+curso.id === +id) {
            this.arrayBusquedaCursos.push(curso);
            // this.textoBusquedaCursos += `${curso.nombre}, `;
          }
        });
      });
      this.textoBusquedaCursos = this.arrayBusquedaCursos.length === 0 ? '' : this.arrayBusquedaCursos.map(item => item.nombre).join(', ');
      this.textoBusquedaAreas = '';
      idsMaterias.split(',').forEach(id => {
        this.areas.map(area => {
          area.materias.map(materia => {
            if (+materia.id === +id) {
              this.arrayBusquedaAreas.push(materia);
              // this.textoBusquedaAreas += `${materia.nombre}, `;
            }
          });
        });
      });
      this.textoBusquedaAreas = this.arrayBusquedaAreas.length === 0 ? '' : this.arrayBusquedaAreas.map(item => item.nombre).join(', ');
      this.textoBusquedaAreas = this.textoBusquedaAreas === '' ? 'Todas' : this.textoBusquedaAreas;
      this.textoBusquedaCursos = this.textoBusquedaCursos === '' ? 'Todos' : this.textoBusquedaCursos;
      this.metasSub = this.mapaCurricularService.getMetasOrigen(idsMaterias, idsCursos)
        .subscribe(res => {
          this.metasSubject.next({op: 'add', items: res});
          this.throbberServ.setThrobberState(false);
        });
    });

    this.mapaCurricularService.getRelatedDocs(
      this.arrayBusquedaAreas.map(item => item.id),
      this.arrayBusquedaCursos.map(item => item.id)
    ).subscribe(
      res => {
        this.documentos = res;
      },
    );

    /*this.unidadesSub = this.mapaCurricularService.getUnidades(idsMaterias, idsCursos).subscribe(res => {
      this.unidadesSubject.next(res);
    });*/
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngAfterContentChecked(): void {
    this.dataReady = true;
    this.cdRef.detectChanges();
    this.filtrosService.emitFiltro();
  }

  ngOnDestroy(): void {
    if (this.metasSub) {
      this.metasSub.unsubscribe();
    }
    if (this.unidadesSub) {
      this.unidadesSub.unsubscribe();
    }
  }

  openMenu() {
    this.menuDocsSubject.next(this.documentos);
    this.trigger.openMenu();
  }

  getMetasColumnData(data) {
    this.throbberServ.setThrobberState(true);
    if (data.checked) {
      this.metasSub = this.mapaCurricularService.getMetas(
        this.route.snapshot.paramMap.get('idsMateria'),
        this.route.snapshot.paramMap.get('idsCurso'),
        data.grouperID)
        .subscribe(res => {
          this.categoriasMetas.find(categoria => categoria.ordenAgrupador === data.grouperID).visible = data.checked;
          this.metasSubject.next({ op: 'add', items: res });
        }, err => {
        },
          () => {
            this.filtrosService.emitFiltro();
          });
    } else {
      this.categoriasMetas.find(categoria => categoria.ordenAgrupador === data.grouperID).visible = false;
      this.metasSubject.next({ op: 'remove', category: data.grouperID });
    }
  }


  getUnitsData(checked, yearID = 0) {
    this.throbberServ.setThrobberState(true);
    if (yearID === 0) {
      yearID = this.periodos[0].id;
    }
    if (checked) {
      this.unidadesSub = this.mapaCurricularService.getUnidades(
        this.route.snapshot.paramMap.get('idsMateria'),
        this.route.snapshot.paramMap.get('idsCurso'),
        yearID
      ).subscribe(res => {
        this.unidadesSubject.next({ op: 'add', items: res });
      }, err => {
      },
        () => {
        });
    } else {
      this.unidadesSubject.next({ op: 'remove', yearID });
    }
  }

  getUnitsDataByYear(data) {
    this.getUnitsData(data.checked, data.periodo.id);
  }

  visibilityUnitBlock(periodo) {
    const unitsSubjectData = this.unidadesSubject.value,
      units = unitsSubjectData.items;
    return units.filter(unit => unit.periodo.id === periodo.id).length > 0;
  }

  abrirDialog(tipo, objeto?) {
    let dialogo;
    if (tipo === 'unidad') {
      if (objeto == null) {
        objeto = new Unidad({ id: 0 });
      }
      dialogo = this.matDialogRef.open(UnidadFormDialogComponent, {
        width: '100%',
        height: '100%',
        maxWidth: '100vw !important',
        maxHeight: 'calc(-64px + 100vh)',
        position: { bottom: '0'},
        disableClose: true,
          data: {
          unidad: objeto,
          materiasPeriodo: this.materiasPeriodo,
          profesores: this.profesores,
          periodos: this.periodos,
          contexto: 'mapa-curricular',
          textoBusquedaCursos: this.textoBusquedaCursos,
          textoBusquedaAreas: this.textoBusquedaAreas,
        }
      });
      const sub = dialogo.componentInstance.onSave.subscribe((unidad) => {
        if (objeto.id === 0) {
          this.unidadesSubject.next({ op: 'add', items: unidad });
        } else {
          this.unidadesSubject.next({ op: 'edit', items: unidad });
        }
        dialogo.close();
      });
      dialogo.afterClosed().subscribe(() => {
        sub.unsubscribe();
      });
    }

    if (tipo === 'meta') {
      let objetoMeta;
      if (objeto == null) {
        objetoMeta = new Meta({ id: 0, htmlES: null, htmlEN: null, htmlFR: null});
      } else {
        objetoMeta = objeto;
      };
      dialogo = this.matDialogRef.open(MetaFormDialogComponent, {
        width: '100%',
        height: '100%',
        maxWidth: '100vw !important',
        maxHeight: 'calc(-64px + 100vh)',
        position: { bottom: '0'},
        disableClose: true,
          data: {
          meta: objetoMeta,
          cursos: this.cursos,
          categorias: this.categoriasMetas,
          areas: this.areas,
          profesores: this.profesores,
          ambitos: this.ambitos,
          tags: this.tags,
          textoBusquedaCursos: this.textoBusquedaCursos,
          textoBusquedaAreas: this.textoBusquedaAreas,
        }
      });
      const sub = dialogo.componentInstance.onSave.subscribe((meta) => {
        if (objeto === null) {
          this.metasSubject.next({ op: 'add', items: meta });
        } else {
          this.metasSubject.next({ op: 'edit', items: meta });
        }
        dialogo.close();
      });
      dialogo.afterClosed().subscribe(() => {
        sub.unsubscribe();
      });
    }
  }

  abrirModalMetas(view: string, categoria: any) {
    const dialogo = this.matDialogRef.open(MapaMetasComponent, {
      width: '100%',
      height: '100%',
      maxWidth: '100vw !important',
      maxHeight: 'calc(-64px + 100vh)',
      position: { bottom: '0'},
      disableClose: true,
      data: {
        grados: this.cursos,
        categorias: this.categoriasMetas,
        materias: this.areas,
        ambitos: this.ambitos,
        tags: this.tags,
        view: view,
        tipoId: categoria.ordenAgrupador,
        currentMaterias: this.arrayBusquedaAreas,
        currentCursos: this.arrayBusquedaCursos,
      }
    });
  }

  limpiarConexiones() {
    this.conexionesService.limpiarConexiones();
  }

  verConexionesActivas(status) {
    this.onlyConnectedVisibilitySubject.next(status);
  }

  getActiveConexionsBool() {
    return this.onlyConnectedVisibilitySubject.value;
  }

  abrirBusqueda() {
    // this.mapaCurricularService.abrirBusqueda();
    this.router.navigate([this.router.routerState.snapshot.url, { outlets: { 'mc-sidebar': ['busqueda'] } }], {
      skipLocationChange: true,
      relativeTo: this.route
    });
  }

  setAccordionsState(value: boolean) {
    this.viewPanels.forEach(p => value ? p.open() : p.close());
  }
}
